module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Opret ny bruger\n    ")]), _vm._v(" "), _c('form', {
    staticClass: "create-user",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "hidden",
      "type": "text",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('label', [_vm._v("Navn *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.name),
      expression: "newUser.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Navn"
    },
    domProps: {
      "value": (_vm.newUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': _vm.newUser.role_id === 4, 'col-lg-6': _vm.newUser.role_id !== 4
    }
  }, [_c('div', {
    staticClass: "role"
  }, [_c('label', [_vm._v("Brugerrolle *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role_id),
      expression: "newUser.role_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Bruger")]), _vm._v(" "), (_vm.availableDepartments.length > 0) ? _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Afdelingsansvarlig")]) : _vm._e(), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Opgaveansvarlig")])])])]), _vm._v(" "), (_vm.newUser.role_id === 4) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('label', [_vm._v("Vælg afdeling *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.relation_department_id),
      expression: "newUser.relation_department_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "relation_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg afdeling ...")]), _vm._v(" "), _vm._l((_vm.availableDepartments), function(department) {
    return (department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet') ? _c('option', {
      key: department.id,
      domProps: {
        "value": department.relation_id
      }
    }, [_vm._v("\n                            " + _vm._s(department.name) + "\n                        ")]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.newUser.role_id === 5) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('label', [_vm._v("Vælg medarbejder *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.relation_employee_id),
      expression: "newUser.relation_employee_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "relation_employee_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg medarbejder ...")]), _vm._v(" "), _vm._l((_vm.employees), function(employee) {
    return _c('option', {
      key: employee.id,
      domProps: {
        "value": employee.relation_id
      }
    }, [_vm._v("\n                            " + _vm._s(employee.full_name) + "\n                        ")])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('label', [_vm._v("E-mail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    attrs: {
      "type": "email",
      "name": "iufbw379fb",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('label', [_vm._v("Adgangskode *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Adgangskode"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Min. 8 karakterer")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.createUser()
      }
    }
  }, [_vm._v("\n                Opret\n            ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Alle brugere\n    ")]), _vm._v(" "), (_vm.users && !_vm.loading) ? _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sortedUsers), function(user) {
    return _c('div', {
      key: user.uuid,
      staticClass: "col-lg-6"
    }, [_c('div', {
      staticClass: "user"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.name),
        expression: "user.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "role"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.role_id),
        expression: "user.role_id"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          user.name = user.name + ' ';
          user.name = user.name.slice(0, -1)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("Bruger")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("Afdelingsansvarlig")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 5
      }
    }, [_vm._v("Opgaveansvarlig")])])]), _vm._v(" "), (user.role_id === 4) ? _c('div', {
      staticClass: "department"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.relation_department_id),
        expression: "user.relation_department_id"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "relation_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Vælg afdeling ...")]), _vm._v(" "), _vm._l((_vm.availableDepartments), function(department) {
      return (department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet') ? _c('option', {
        key: department.id,
        domProps: {
          "value": department.relation_id
        }
      }, [_vm._v("\n                                " + _vm._s(department.name) + "\n                            ")]) : _vm._e()
    })], 2)]) : _vm._e(), _vm._v(" "), (user.role_id === 5) ? _c('div', {
      staticClass: "department"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.relation_employee_id),
        expression: "user.relation_employee_id"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "relation_employee_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Vælg medarbejder ...")]), _vm._v(" "), _vm._l((_vm.employees), function(employee) {
      return _c('option', {
        key: employee.id,
        domProps: {
          "value": employee.relation_id
        }
      }, [_vm._v("\n                                " + _vm._s(employee.full_name) + "\n                            ")])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "email"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.email),
        expression: "user.email"
      }],
      attrs: {
        "type": "email"
      },
      domProps: {
        "value": (user.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "password"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.new_password),
        expression: "user.new_password"
      }],
      attrs: {
        "type": "password",
        "placeholder": "Evt. ny adgangskode"
      },
      domProps: {
        "value": (user.new_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "new_password", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.updateUser(user)
        }
      }
    }, [_vm._v("\n                            Opdatér\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.deleteUser(user)
        }
      }
    }, [_vm._v("\n                            Slet\n                        ")])])])])
  }), 0)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [_c('b', [_vm._v("Administrator:")]), _vm._v(" Adgang til alle faner og kan ændre indstillinger, administrere brugere mv.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Bruger:")]), _vm._v(" Læseadgang til alle faner.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Afdelingsansvarlig:")]), _vm._v(" Læseadgang til alle faner undtagen økonomi-relaterede faner og potentiale. Kan kun se data for sin egen afdeling.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Opgaveansvarlig:")]), _vm._v(" Læseadgang til ens personlige værdikæde.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59df3e14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/users.vue
// module id = 874
// module chunks = 0